import styled from 'styled-components';

export const GroupContainer = styled.div<{ overlap: string }>`
  display: flex;
  align-items: center;

  & > div {
    margin-left: -${(props) => props.overlap};
  }

  & > div:first-child {
    margin-left: 0;
  }
`;
